<template>
  <div class="mb-32 mx-auto">
    <h2 class="py-2 font-semibold uppercase tracking-wide text-xs border-b border-blackish">
      {{ $t('profile.coupons') }}
    </h2>
    <section class="mt-5 flex font-bold text-xxs md:text-xs w-full justify-between pl-2">
      <h3 class="w-1/5">
        {{ $t('coupons.code') }}
      </h3>
      <h3 class="w-1/3">
        {{ $t('coupons.description') }}
      </h3>
      <h3 class="w-1/5 text-center">
        {{ $t('coupons.value') }}
      </h3>
      <h3 class="w-1/4 text-center">
        {{ $t('coupons.uses') }}
      </h3>
      <h3 class="w-1/4 text-right">
        {{ $t('coupons.expiration') }}
      </h3>
    </section>
    <div v-if="coupons.length > 0">
      <coupon-row
        v-for="coupon in coupons"
        :key="coupon.id"
        :coupon="coupon"
        class="mt-4" />
    </div>
    <div v-else class="text-sm pt-10 pl-2">
      {{ $t('coupons.noCoupons') }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCustomerPersonalCoupons } from '@/services/OrdersService';
import CouponRow from './CouponRow.vue';

export default {
  components: { CouponRow },
  metaInfo() {
    const title = this.$t('titles.coupons');
    return {
      title,
      meta: [
        {
          name: 'description',
          content: 'Your coupons',
        },
      ],
    };
  },

  data() {
    return {
      coupons: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      changedLocale: 'auth/changedLocale',
    }),
  },

  watch: {
    changedLocale() {
      this.getCoupons();
    },
  },

  created() {
    this.getCoupons();
  },

  methods: {
    getCoupons() {
      getCustomerPersonalCoupons(this.user.customer.id, null).then(({ data }) => {
        this.coupons = data;
      });
    },
  },
};
</script>
